import {getTokenByUsername} from "@/api/im.js";
import {getPlatformUser} from "@/api/login.js";
import {userAddGroupId} from "@/api/user.js";
import Vue from "vue";

const im = {
  state: {
    imUser: '',
    systemUnreadCount: 0,
  },
  mutations: {
    SET_IM_USER(state, user) {
      state.imUser = user
    },
    SET_SYSTEM_UNREAD_COUNT(state, count) {
      state.systemUnreadCount = count
    },
  },
  actions: {
    updateSystemUnreadCount({commit}, count) {
      commit('SET_SYSTEM_UNREAD_COUNT', count)
    },
    //  获取用户消息
    async getImInfo({commit, rootGetters, dispatch}) {
      let id = Number(rootGetters.shelfId).toString(16);
      let user = '10000000' + id;
      let payload = {
        user,
        pwd: user,
      }
      commit('SET_IM_USER', user)
      let appkey = Vue.prototype.$webIM.config.appkey
      let localAppkey = localStorage.getItem('localAppkey')
      if (appkey === localAppkey && localStorage.getItem('accessToken') && user === localStorage.getItem('imUser')) {
        payload.accessToken = localStorage.getItem('accessToken');
      } else {
        let {data} = await getTokenByUsername({username: user})
        localStorage.setItem('accessToken', data)
        localStorage.setItem('imUser', user)
        localStorage.setItem('localAppkey', appkey)
        payload.accessToken = data
      }
      if (!rootGetters.shelfId) {
        setTimeout(() => {
          dispatch('getImInfo')
        }, 1000)
      } else {
        dispatch('onLogin', payload)
      }
    },
    // 登录
    async onLogin({commit, dispatch, state}, payload) {
      try {
        if (!payload.accessToken) {
          return;
        }
        let options = {
          user: payload.user,
          // pwd: this.payload.pwd,
          accessToken: payload.accessToken,
          appKey: Vue.prototype.$webIM.config.appkey,
          apiUrl: 'https://a1.easecdn.com'
        };
        await Vue.prototype.$webIM.conn.open(options)
        dispatch('updateUser')
        dispatch('getContactList')
      } catch (err) {
        localStorage.removeItem('accessToken')
        // if (err.type !== 208 && err.type !== 1) {
        //   localStorage.removeItem('accessToken')
        //   setTimeout(() => {
        //     dispatch('getImInfo')
        //   }, 20000)
        // }
      }
    },
    // 获取会话列表准备创建群聊
    async getContactList({commit, dispatch, state}) {
      let {data} = await getPlatformUser({roleName: '客服', delFlag: 1, status: 1})
      let admin = 'admin';
      let customerIds = data.map(e => {
        return {name: e.username, id: admin + e.id}
      })
      // pageSize: 每页期望获取的会话数量。取值范围为 [1,50]，默认为 `20`。
      // cursor：开始获取数据的游标位置。若传空字符串（''），SDK 从最新活跃的会话开始获取。
      Vue.prototype.$webIM.conn.getServerConversations({pageSize: 500, cursor: ''}).then(async (res) => {
        let data = res.data;
        let contactArr = data.conversations && Array.isArray(data.conversations) ? data.conversations : [];
        let allContactList = contactArr.filter(item => item.conversationType === "groupChat");
        let isHaveGroupChat = allContactList.length > 0;
        if (!isHaveGroupChat) {
          // 会话列表没有群组去创建添加进去
          dispatch('getGroupList', customerIds)
        } else {
          let idsByCustomerId = customerIds.map(e => e.id)
          // 有群聊获取群聊信息以及处理客服人员列表
          let newObj = allContactList.find(item => item.conversationType === "groupChat");
          dispatch('getHasGroup', {newObj, idsByCustomerId})
          dispatch('setUserAddGroupId', newObj)
        }
      })
    },
    getGroupList({dispatch, rootGetters}, customerIds) {
      // let option = {
      //   groupId: "281525418524675",
      // };
      // Vue.prototype.$webIM.conn.destroyGroup(option).then((res) => console.log(res));
      // return;
      let par = {
        pageNum: 0,
        pageSize: 20,
        needAffiliations: true,
        needRole: true,
      }
      Vue.prototype.$webIM.conn.getJoinedGroups(par).then(async res => {
        if (!res.entities || res.entities.length === 0 || res.total === 0) {
          dispatch('creteMyGroup', customerIds)
        } else {
          let obj = res.entities[0] || {}
          let newObj = {
            "conversationId": obj.groupId,
            "conversationType": `groupChat`,
            "nickname": '货主-' + rootGetters.shelfName,
            "isPinned": false,
            "pinnedTime": 0,
            "unReadCount": 0,
          }
          dispatch('setUserAddGroupId', newObj)
          let idsByCustomerId = customerIds.map(e => e.id)
          dispatch('getHasGroup', {newObj, idsByCustomerId})
        }
      })
    },
    // 创建群聊
    creteMyGroup({state, rootGetters, dispatch}, customerIds) {
      let idsByCustomerId = customerIds.map(e => e.id)
      let members = [state.imUser, ...idsByCustomerId];
      let option = {
        data: {
          groupname: '货主-' + rootGetters.shelfName,
          desc: "A description of a group ",
          members,
          public: true,
          approval: false,
          allowinvites: true,
          inviteNeedConfirm: false,
          maxusers: 500,
          ext: "group detail extensions",
        },
      };
      Vue.prototype.$webIM.conn.createGroup(option).then(res => {
        setTimeout(() => {
          dispatch('getGroupList', customerIds)
        }, 300)
      })
    },
    // 获取群聊详情
    async getHasGroup({rootGetters}, {newObj, idsByCustomerId}) {
      // 获取客服群对象
      let GroupObj = newObj;
      let {data} = await Vue.prototype.$webIM.conn.getGroupInfo({groupId: GroupObj.conversationId});
      GroupObj.nickname = '货主-' + rootGetters.shelfName;
      // 获取群员ids
      GroupObj.affiliations = data[0].affiliations.map(e => e.owner || e.member)
      let newCustomer = [];
      // 判断群组客服列表有没有缺少的客服，有则添加到newCustomer
      idsByCustomerId.forEach(id => {
        if (GroupObj.affiliations.indexOf(id) === -1) {
          newCustomer.push(id);
        }
      })
      if (newCustomer.length > 0) {
        await Vue.prototype.$webIM.conn.inviteUsersToGroup({groupId: GroupObj.conversationId, users: newCustomer});
      }
    },
    async setUserAddGroupId({rootGetters}, newObj) {
      if (!newObj || !newObj.conversationId) {
        return;
      }
      let par = {
        groupId: newObj.conversationId,
        shelfId: rootGetters.shelfId
      }
      await userAddGroupId(par)
      let option = {
        groupId: newObj.conversationId,
        groupName: '货主-' + rootGetters.shelfName,
        description: "A description of group",
        ext: "group detail extensions",
      };
      Vue.prototype.$webIM.conn.modifyGroup(option).then(res => {
      })
    },
    // 更新用户属性
    async updateUser({rootGetters}) {
      let option = {
        nickname: rootGetters.shelfName,
        // nickname: '货主',
        avatarurl: rootGetters.icon || "",
      };
      await Vue.prototype.$webIM.conn.updateUserInfo(option).then((res) => {
      });
    },
  }
}

export default im



// WEBPACK FOOTER //
// ./src/store/modules/im.js